import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ProgramBanner from "../Components/ProgramBanner/ProgramBanner";
import { useHttpClient } from "../hooks/http-hook";
import { Row, Col, Button } from "react-bootstrap";
import ModuleAccordion from "../Components/ModuleAccordion/ModuleAccordion";
import ProgramMembers from "../Components/ProgramMembers/ProgramMembers";
import ModuleProgression from "../Components/AccordionProgressionModule/ModuleProgression";
import { useAuth } from "../Context/AuthContext";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function Program() {
  const { sendRequest } = useHttpClient();
  const [program, setProgram] = useState(null);
  const [selection, setSelection] = useState("");
  const [members, setMembers] = useState([]);
  const { authData } = useAuth();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isCreator, setIsCreator] = useState(false);
  const { t } = useTranslation(); // Assigner useTranslation à {t}

  const { id } = useParams();
  console.log(id);

  useEffect(() => {
    const fetchProgram = async () => {
      try {
        const response = await sendRequest(
          process.env.REACT_APP_BACKEND_URL + `/programs/${id}`
        );

        const programData = response.program;

        const allMembers = [
          programData.created_by,
          ...programData.instructors,
          ...programData.students_enrolled,
        ].filter((member) => member);

        const isMember = allMembers.some((member) => {
          const memberId = member?._id || member;
          return memberId && memberId.toString() === authData.userId;
        });

        const isCreator = programData.created_by
          ? programData.created_by._id === authData.userId
          : false;

        setIsCreator(isCreator);
        setIsAuthorized(isMember);
        setProgram(programData);
        setMembers(allMembers);
      } catch (error) {
        console.error("Error fetching program:", error);
      }
    };

    fetchProgram();
    setSelection("modules");
  }, [id, sendRequest, authData.userId]);

  return program ? (
    <div>
      <ProgramBanner program={program} />
      <Row className="w-100 mt-4 d-flex justify-content-center px-5">
        <Col xs="auto">
          <Button
            variant={
              selection === "modules" ? "outline-primary" : "outline-white"
            }
            className="me-2"
            onClick={() => {
              setSelection("modules");
            }}
          >
            {t("modules")}
          </Button>
        </Col>

        {isAuthorized && (
          <>
            <Col xs="auto">
              <Button
                variant={
                  selection === "progressions"
                    ? "outline-primary"
                    : "outline-white"
                }
                className="me-2"
                onClick={() => {
                  setSelection("progressions");
                }}
              >
                {t("progression")}
              </Button>
            </Col>
            <Col xs="auto">
              <Button
                variant={
                  selection === "membres" ? "outline-primary" : "outline-white"
                }
                className="ms-2"
                onClick={() => {
                  setSelection("membres");
                }}
              >
                {t("members")}
              </Button>
            </Col>
          </>
        )}
      </Row>
      {selection === "modules" ? (
        <ModuleAccordion program={program} />
      ) : selection === "membres" && isAuthorized ? (
        <ProgramMembers
          members={members}
          setMembers={setMembers}
          program={program}
        />
      ) : selection === "progressions" && isAuthorized ? (
        <ModuleProgression
          members={members}
          program={program}
          isCreator={isCreator}
        />
      ) : (
        <ModuleAccordion program={program} />
      )}
    </div>
  ) : null;
}

export default Program;
